<span (uClickOutside)="closeDesktopMenu()" [attr.menu-open]="menuIsOpen">
  <button (click)="openDesktopMenu()" (focus)="openDesktopMenu()" [attr.aria-label]="select_text" data-automation="open-menu"><i class="flag-icon flag-icon-{{current_flag}}" [attr.menu-open]="menuIsOpen"></i></button>
  <u-choose-locale [attr.menu-open]="menuIsOpen"></u-choose-locale>
</span>

<div class="overlay">&nbsp;</div>
